module.exports = __webpack_public_path__ + "7a12dec1c23b444bcbb6be86660942c4.svg";